import { Stack } from "@mantine/core";
import { SecondaryButton } from "../ui/buttons";
import { Notice } from "../ui/Notice";

/** The shell's own load failure (/v1/me): what went wrong, and a retry. */
export function ErrorState({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <Stack maw={560} gap="md">
      <Notice tone="danger" title="We couldn't load your account">
        {message}
      </Notice>
      <SecondaryButton onClick={onRetry} w="fit-content">
        Try again
      </SecondaryButton>
    </Stack>
  );
}
